<template>
  <div>
    <h4 v-html="getTitle" class="mb-3"></h4>
    <div v-html="getDescription"></div>
    
      <div class="_card-columns mt-5">
        <b-row class="pl-1 pr-1">
          <shop-product-item
            v-for="(ShopProductItem, index) in panelData"
            :key="index"    
            :index="index"    
            :ShopProductItem="ShopProductItem"/>
       </b-row>
      </div>   
  </div>
</template>

<script>
import ShopProductItem from "@/components/ShopProductItem";

export default {
  name: "ShopCategoryPanel",
  props: ["selectedCategory" /* the selected Category id */],
  components: {
    ShopProductItem /* one single product */
  },
  computed: {
    getSelectedLanguage() {
      return this.$store.getters.getLanguage;
    },
    getTitle() {
      return this.group.title;
    },
    getDescription() {
      return this.group.description;
    }
  },
  methods: {
    async loadProductsFromServer(groupId) { // for a title/description on top

    let config2 = JSON.parse(JSON.stringify(this.$store.getters.getRestHeaderConfig));
    delete config2.params;

  
    config2.params = {
          groupId: groupId,
          imageSize: "medium" /* small, medium, big */,
          localeId: this.getSelectedLanguage.ident /* Language: de, en */
        };
    
     // console.log('loadProductsFromServer2:', groupId, config2 );

      await this.$http
        .get(this.$store.getters.getRestServerBaseUrl + "/productGroupDetail", config2)
        .then(response => {
         // console.log("product Group Detail OK: " + response.status);
          // Check Data ?
          this.group = response.data;
        })
        .catch(err => {
          console.log('get Group Detail error:', err);
          this.group = {};
        });


      // same Header for both requests
      await this.$http
        .get(this.$store.getters.getRestServerBaseUrl + "/products", config2)
        .then(response => {
          //console.log("products OK: " + +response.status + " " + response.data.length);
          //console.log(response.data);

          // go to the produktpage if there is only one
          if( response.data.length == 1){
           // console.log('/app/'+ response.data[0].type +'/' + response.data[0].id);
            
            this.$router.push('/app/'+ response.data[0].type +'/' + response.data[0].id);

          }else{
            this.panelData = response.data;
          }

          
        })
        .catch(err => {
          console.log('get Product failed: ', err);
          this.panelData = [];
        });
    }
  },
  data() {
    return {
      CardOptions: {
        imageAlt: "ProductImage",
        tag: "div",
        titleClass: "card-text p-0",
        style: 'cursor: pointer;',
        class: "mb-1"
      },
      panelData: [],
      group: {}
    };
  },
  beforeMount() {
    /* Load GroupInfo and Products to show in Panel */
    //console.log('CategoryPanel: ', this.selectedCategory);
    
    this.loadProductsFromServer(this.selectedCategory);
  },  
};
</script>
